import { render } from "./BankAccountShow.vue?vue&type=template&id=88ff9634"
import script from "./BankAccountShow.vue?vue&type=script&lang=js"
export * from "./BankAccountShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__